let BaseUiConfig = {
	typingTimeout: 500
};

export { BaseUiConfig };